import { Inbox, MessageSquare, CheckCircle2, ShieldAlert } from "lucide-react";
import { KidAvatar } from "../Brand";

const Stat = ({ label, value, icon: Icon, bg, id, onClick }) => (
  <button data-testid={id} onClick={onClick} className="zn-card p-5 text-left hover:-translate-y-1" style={{ background: bg, transition: "transform 150ms ease" }}>
    <Icon size={24} className="mb-3" />
    <p className="font-display text-4xl font-bold">{value ?? "–"}</p>
    <p className="text-sm font-semibold">{label}</p>
  </button>
);

export const Overview = ({ stats, goTo }) => (
  <div className="space-y-8">
    <div>
      <h1 className="text-4xl font-bold mb-1">Family overview</h1>
      <p className="text-[#1B1A2E]/70">Here's what your little creators are up to today.</p>
    </div>
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-5">
      <Stat id="stat-pending-videos" label="Videos to review" value={stats?.pending_videos} icon={Inbox} bg="#FFD23F" onClick={() => goTo("approvals")} />
      <Stat id="stat-pending-comments" label="Comments to review" value={stats?.pending_comments} icon={MessageSquare} bg="#FF8FC7" onClick={() => goTo("approvals")} />
      <Stat id="stat-approved-videos" label="Live videos" value={stats?.approved_videos} icon={CheckCircle2} bg="#B8F2C9" onClick={() => goTo("videos")} />
      <Stat id="stat-blocked-today" label="AI blocked today" value={stats?.blocked_today} icon={ShieldAlert} bg="#3DCCC7" onClick={() => goTo("activity")} />
    </div>
    <div className="zn-card p-6 bg-white">
      <h2 className="text-2xl font-bold mb-5">Screen time today</h2>
      {stats?.kids?.length === 0 && <p data-testid="overview-no-kids">Add a kid profile to get started.</p>}
      <div className="space-y-5">
        {stats?.kids?.map((k) => {
          const limit = k.settings.daily_limit_minutes;
          const pct = Math.min(100, Math.round((k.minutes_used_today / limit) * 100));
          return (
            <div key={k.id} data-testid={`screen-time-row-${k.id}`} className="flex items-center gap-4">
              <KidAvatar avatar={k.avatar} color={k.color} frame={k.frame} size={44} />
              <div className="flex-1">
                <div className="flex justify-between text-sm font-semibold mb-1"><span>{k.name}</span><span>{k.minutes_used_today} / {limit} min</span></div>
                <div className="h-4 rounded-full border-[3px] border-[#1B1A2E] bg-[#FFF7EC] overflow-hidden">
                  <div className="h-full" style={{ width: `${pct}%`, background: pct >= 100 ? "#FF6B4A" : "#7B5CFA" }} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);
